import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import HelmetWrapper from "../../HelmetWrapper";
import UREStructure from "./UREStructure";
import Notifications from "../../components/push-notifications/Notifications";

const UREOpen = () => {
  const navigate = useNavigate();
  const [pageState, setPageState] = useState(
    JSON.parse(localStorage.getItem("pageState"))
  );
  const { decryptedText: userInfoData, isCustom } = pageState || {};

  const isIOS = () => {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  };

  useEffect(() => {
    const savedState = localStorage.getItem("pageState");

    if (savedState) {
      try {
        setPageState(JSON.parse(savedState));
      } catch (error) {
        console.error("Error parsing saved state:", error);
      }
    }
  }, []);

  useEffect(() => {
    if (!pageState) {
      navigate("/open-access");
    }
  }, [pageState]);

  // const location = useLocation();
  // const { decryptedText: userInfoData, isCustom } = location.state || {};
  // useEffect(() => {
  //   if (!userInfoData) {
  //     navigate("/open-access");
  //   }
  // }, [userInfoData]);

  return (
    <HelmetWrapper title="WTF: Renewal/Expiring/Unpaid Members">
      {userInfoData && !isIOS() && <Notifications authData={userInfoData} />}
      <UREStructure userInfoData={userInfoData} isOpen={isCustom} />
    </HelmetWrapper>
  );
};

export default UREOpen;
